import React from "react";

const Footer = () => {
  return (
    <footer className="py-4 bg-white bg-opacity-80 backdrop-blur-sm border-t border-gray-200">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="flex-1 hidden md:block" />
        
        <p className="text-sm text-gray-700 text-center">
          © 2026 Whiteswan Security. All rights reserved.
        </p>
        
        <div className="flex gap-6 mr-0 md:mr-5">
          <a
            href="https://app.termly.io/document/terms-of-service/d8371bb3-6629-4b1e-95c5-3cf56e89c51c"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-700 hover:text-indigo-600 transition-colors"
          >
            Terms and Conditions
          </a>
          <a
            href="https://www.whiteswansecurity.com/about/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-700 hover:text-indigo-600 transition-colors"
          >
            About
          </a>
          <a
            href="https://www.whiteswansecurity.com/contact/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-700 hover:text-indigo-600 transition-colors"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
